"use client";

import useCorrectRoute from "./useCorrectRoute";

export default function CorrectRouteHandler({ canonical }) {
  useCorrectRoute(canonical);

  return null;
}
